<h1 class="page-title mb-5">الشكاوى</h1>
<div dir="rtl">
</div>

<div class="container">
  <fieldset class="form-section">
    <legend class="section-title">بيانات مقدم الشكوى</legend>
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label required">اسم مقدم الشكوى بالكامل</label>
        <input type="text" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">عنوان المراسلات</label>
        <input type="text" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">رقم الهاتف المحمول</label>
        <input type="tel" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">البريد الالكتروني</label>
        <input type="email" class="form-control" />
      </div>
    </div>
  </fieldset>

  <fieldset class="form-section mt-5">
    <legend class="section-title">بيانات الشركة</legend>
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label required">اسم الشركة المقيد بالسجل التجاري</label>
        <input type="text" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">عنوان المقر الاداري/موقع ممارسة النشاط</label>
        <input type="text" class="form-control" />
      </div>

      <div class="col-md-6">
        <label class="form-label required">تليفون الشركة</label>
        <input type="tel" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">تاريخ تأسيس الشركة</label>
        <div class="date-custom-wrapper">
          <app-custom-date-input
            [backgroundColor]="'white'" [validationType]="'past-only'">
          </app-custom-date-input>

          <div class="icon-box">
            <i class="fa-solid fa-calendar-days"></i>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label required">رقم القيد بالسجل التجاري</label>
        <input type="text" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">تاريخ القيد بالسجل التجاري</label>
        <div class="date-custom-wrapper">
          <app-custom-date-input
            [readOnly]="false"
            [backgroundColor]="'white'">
          </app-custom-date-input>

          <div class="icon-box">
            <i class="fa-solid fa-calendar-days"></i>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label required">قانون التأسيس</label>
        <select class="form-select">
          <option selected disabled>اختر قانون التأسيس</option>
          <option>قانون 72 لسنة 2017</option>
          <option>قانون 159 لسنة 1981</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label required">الشكل القانوني للشركة</label>
        <select class="form-select">
          <option selected disabled>اختر الشكل القانوني للشركة</option>
          <option>شركة مساهمة</option>
          <option>شركة ذات مسئولية محدودة</option>
        </select>
      </div>

      <div class="col-md-6">
        <label class="form-label required">نوع الاستثمار</label>
        <select class="form-select">
          <option selected disabled>اختر نوع الاستثمار</option>
          <option>داخلي</option>
          <option>مناطق حرة</option>
        </select>
      </div>
    </div>

    <div class="subsection mt-4 mb-4">
      <div class="mb-3 shareholder-header">
        <h5 class="m-0">جنسية المساهمين ونسبة المساهمة</h5>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="addShareholder" />
          <label class="form-check-label" for="addShareholder">إضافة مساهم</label>
        </div>
      </div>
      <div class="shareholder-box"></div>
    </div>

    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label required">نشاط الشركة</label>
        <input type="text" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">رأس المال المصدر</label>
        <input type="number" class="form-control" />
      </div>

      <div class="col-md-6">
        <label class="form-label required">رأس المال المدفوع</label>
        <input type="number" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">العملة</label>
        <select class="form-select">
          <option selected disabled>اختر العملة</option>
          <option>جنيه مصري</option>
          <option>دولار أمريكي</option>
        </select>
      </div>

      <div class="col-md-6">
        <label class="form-label required">التكاليف الاستثمارية</label>
        <input type="number" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">قيمة الاستثمارات المعطلة نتيجة الشكوى</label>
        <input type="number" class="form-control" />
      </div>

      <div class="col-md-6">
        <label class="form-label required">عدد العاملين</label>
        <input type="number" class="form-control" />
      </div>
      <div class="col-md-6">
        <label class="form-label required">الموقف التنفيذي</label>
        <select class="form-select">
          <option selected disabled>اختر الموقف التنفيذي</option>
          <option>تحت الإنشاء</option>
          <option>بدء النشاط</option>
        </select>
      </div>
    </div>
  </fieldset>

  <fieldset class="form-section mt-5">
    <legend class="section-title">ملخص موضوع الشكوى</legend>
    <p class="text-muted small mb-3">
      برجاء وصف الشكوى بشكل محدد ,رجاء التأكد من القيام بوصف دقيق للشكوى المقدمة
      و استيفاء النقاط التالية لكافة الشكاوى التي يتم ذكرها: موضوع الشكوى<br />
      الجهة المشكو منها<br />
      وصف المشكلة و مدتها الزمنية<br />
      اسباب المشكلة و ما ترتب عليها من اضرار للشركة
    </p>
    <div class="mb-3">
      <label class="form-label required">ملخص موضوع الشكوى</label>
      <textarea class="form-control" rows="5"></textarea>
    </div>
  </fieldset>

  <fieldset class="form-section mt-5">
    <legend class="section-title">الإجراءات السابقة على تقديم الطلب</legend>
    <p class="mb-3">هل سبق لك وان تقدمت بشكوى لجهة مما يلي:</p>
    <div class="checks-group">
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="check1" />
        <label class="form-check-label" for="check1">اللجنة الوزارية لفض منازعات الاستثمار</label>
      </div>
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="check2" />
        <label class="form-check-label" for="check2">تسوية منازعات الاستثمار</label>
      </div>
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="check3" />
        <label class="form-check-label" for="check3">لجنة تسوية منازعات عقود الاستثمار</label>
      </div>
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="check4" />
        <label class="form-check-label" for="check4">جهات اخرى تذكر</label>
      </div>
    </div>
  </fieldset>

  <fieldset class="form-section mt-5">
    <legend class="section-title">المرفقات المطلوبة</legend>
    <div class="row g-4">
      <div class="col-md-6">
        <label class="form-label required">صورة حديثة من السجل التجاري لم يمر عليها اكثر من 3 اشهر</label>
        <div class="input-group custom-file-button">
          <input type="file" class="form-control" id="file1" placeholder="No file chosen" />
        </div>
        <small class="text-muted d-block mt-1 text-end" style="direction: ltr">No file chosen</small>
      </div>
      <div class="col-md-6">
        <label class="form-label required">صورة المخاطبات مع الجهات الاخرى</label>
        <div class="input-group custom-file-button">
          <input type="file" class="form-control" id="file2" />
        </div>
        <small class="text-muted d-block mt-1 text-end" style="direction: ltr">No file chosen</small>
      </div>
      <div class="col-md-6 ms-auto">
        <label class="form-label">اية مستندات اخرى مؤيدة للشكوى</label>
        <div class="input-group custom-file-button">
          <input type="file" class="form-control" id="file3" multiple />
        </div>
        <small class="text-muted d-block mt-1 text-end" style="direction: ltr">No file chosen</small>
      </div>
    </div>
  </fieldset>

  <div class="footer-actions mt-5 mb-5">
    <div class="form-check d-flex justify-content-start align-items-center gap-2 mb-3">
      <label class="form-check-label required" for="filledByApplicant">تم الإستيفاء بواسطة مقدم الطلب</label>
      <input class="form-check-input" type="checkbox" id="filledByApplicant" />
    </div>
    <div class="text-end">
      <button class="btn btn-success px-5 py-2">إرسال الشكوى</button>
    </div>
  </div>
</div>